import {UniversalLoginInstance} from 'app/modules/auth/types/universalLogin'

import {
  buildUniversalLoginRedirectUrl,
  setUniversalLoginCanonicalDomain,
} from './universalLoginHandoff'

type UniversalLoginResult = {
  redirectUrl?: string
  instances?: UniversalLoginInstance[]
}

/** Apply universal-login success (email or Google): redirect to school handoff URL. */
export const applyUniversalLoginRedirect = (result?: UniversalLoginResult): boolean => {
  const redirectUrl = result?.redirectUrl
  if (!redirectUrl) return false

  const canonicalDomain = result?.instances?.[0]?.canonicalDomain
  if (canonicalDomain) {
    setUniversalLoginCanonicalDomain(canonicalDomain)
  }
  window.location.replace(buildUniversalLoginRedirectUrl(redirectUrl, canonicalDomain))
  return true
}

export const isUniversalLoginConflict = (res: {
  statusCode?: number
  result?: {instances?: UniversalLoginInstance[]}
}): boolean => res?.statusCode === 409 && Boolean(res?.result?.instances?.length)

const NO_ACCOUNT_MESSAGE = 'No account found. Please Sign Up.'

export const getUniversalLoginErrorMessage = (
  message?: string,
  statusCode?: number,
  fallback = 'Invalid username or password'
): string => {
  const lower = (message ?? '').toLowerCase()
  if (
    statusCode === 404 ||
    lower.includes('no account found with this email') ||
    lower.includes('no account found for this')
  ) {
    return NO_ACCOUNT_MESSAGE
  }
  return message || fallback
}
